import { useState } from "react";
import { Play } from "lucide-react";

const VIDEO_ID = "Q3jfzKgShY8";

export const ProductVideo = () => {
  const [play, setPlay] = useState(false);
  return (
    <div data-testid="product-video" className="mt-16 flex flex-col gap-5">
      <h3 className="font-display text-2xl sm:text-3xl font-bold text-white">Découvrez le PortaSplit en vidéo</h3>
      <div className="relative w-full aspect-video rounded-3xl overflow-hidden ring-1 ring-white/10 bg-black">
        {play ? (
          <iframe
            data-testid="product-video-iframe"
            src={`https://www.youtube-nocookie.com/embed/${VIDEO_ID}?autoplay=1&rel=0`}
            title="Midea PortaSplit en vidéo"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="absolute inset-0 w-full h-full"
          />
        ) : (
          <button type="button" onClick={() => setPlay(true)} data-testid="product-video-play-button" aria-label="Lire la vidéo" className="group absolute inset-0 w-full h-full">
            <img src={`https://i.ytimg.com/vi/${VIDEO_ID}/maxresdefault.jpg`} alt="Aperçu de la vidéo Midea PortaSplit" className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity" loading="lazy" />
            <span className="absolute inset-0 flex items-center justify-center">
              <span className="w-20 h-20 rounded-full bg-orange-600 text-white flex items-center justify-center shadow-2xl transition-transform group-hover:scale-110">
                <Play className="w-8 h-8 ml-1" fill="currentColor" />
              </span>
            </span>
          </button>
        )}
      </div>
    </div>
  );
};
